import styled from "styled-components";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";

export const AboutPinkStoriesContainer = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0 24px;
`;

export const AboutPinkStoriesWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${Colors.brandColor};
  padding: 48px 55px 37px;
  border-radius: 6px;

  @media ${deviceMax.tablet} {
    background-color: unset;
    padding: 0;
  }
`;

export const AboutPinkStoriesTitle = styled.h2`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.white};
  margin-top: 0;

  @media ${deviceMax.tablet} {
    letter-spacing: 0;
    color: ${Colors.blackColor};
    text-align: center;
  }
`;

export const AboutPinkStoriesContentTitle = styled.h3`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.white};
  margin-top: 13px;

  @media ${deviceMax.tablet} {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${Colors.blackColor};
    margin-top: 23px;
  }
`;

export const AboutPinkStoriesContentText = styled.p`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.white};

  @media ${deviceMax.tablet} {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${Colors.blackColor};
  }
`;

export const AboutPinkStoriesButtonDesktop = styled.div`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin-top: 8px;

  @media ${deviceMax.tablet} {
    display: none;
  }

  > div {
    display: inline-block;
    padding: 0;
    margin-bottom: 0;

    > a {
      display: inline-block;
    }
  }
`;

export const AboutPinkStoriesButtonMobile = styled.div`
  position: relative;
  display: none;

  @media ${deviceMax.tablet} {
    display: block;
    width: fit-content;
    margin: 13px auto 16px;
  }

  > div {
    display: inline-block;
    padding: 0;
    margin-bottom: 0;

    > a {
      display: inline-block;
    }
  }
`;
